<template>
	<ApiErrorCard v-if="apiError" :error="apiError" />
	<div
		v-else
		class="grid grid-cols-1 gap-4 lg:grid-cols-2 overflow-x-auto max-h-64"
	>
		<template v-if="documents.length > 0">
			<LoanOfferDocumentsGridItem
				v-for="doc in documents"
				:key="doc.id"
				:doc="doc"
				:download-url="doc.url"
			/>
		</template>
		<div
			v-else
			class="items-center justify-center hidden col-span-2 gap-2 text-gray-500 opacity-100 only:flex min-h-32"
		>
			Geen documenten gevonden
		</div>
	</div>
</template>

<script lang="ts" setup>
import type { ReadOfferDocument } from "@/generatedApi";
import { api } from "@/loanLinkApi";
import type { ApiError } from "@/models/ApiError";
import { onMounted, ref } from "vue";

interface Props {
	applicationId: string;
	offerId: string;
}
const props = defineProps<Props>();
const documents = ref<ReadOfferDocument[]>([]);
const apiError = ref<ApiError | null>(null);

onMounted(async () => {
	await api.loanApplication
		.getOfferDocuments(props.applicationId, props.offerId)
		.then((data) => {
			documents.value = data.data ?? [];
		})
		.catch((res) => {
			apiError.value = res.error;
		});
});
</script>
